import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoSearchService, IBaseDto } from './base-dto.service';
import { OpportunityClient, QuickSearchOpportunitiesParameters } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingOpportunitiesSearchService extends BaseDtoSearchService {
    constructor(protected client: OpportunityClient) {
        super();
    }

    async search(filterText: string): Promise<IBaseDto[]> {
        return await lastValueFrom(
            this.client.opportunityQuickSearch({ filterText, isActive: true } as QuickSearchOpportunitiesParameters)
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    override getById(ids: number): Promise<IBaseDto> {
        throw new Error('Method not implemented.');
    }

    async getByIds(opportunityIds: number[]): Promise<IBaseDto[]> {
        return await lastValueFrom(
            this.client.opportunityQuickSearch({ opportunityIds } as QuickSearchOpportunitiesParameters)
        );
    }
}
